import AppbarTauron from './AppbarTauron';

export default AppbarTauron;
